export default __webpack_public_path__ + "d6e43c98aa99aad9d53cc8c22e206b89.png";